import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";
import InputDateUI from "../../../widgets/form/InputDateUI";

const CustomerInvoicesCreateModalUI = ({
	context, successMsg, errorList, setErrorList, customerList,
	createMode, onSubmit, submitted, onCancelCreate, invoiceName, onInvoiceNameChange, invoiceNameError,
	setInvoiceNameError, customerNotes, onCustomerNotesChange, customerNotesError,
	setCustomerNotesError, customerId, onCustomerIdChange, customerIdError,
	setCustomerIdError,
	invoiceNumber, onInvoiceNumberChange, invoiceNumberError, setInvoiceNumberError,
	eWayBill, onEWayBillChange, eWayBillError, setEWayBillError,
	vehicleNumber, onVehicleNumberChange, vehicleNumberError, setVehicleNumberError,
	dateOfSupply, onDateOfSupplyChange, dateOfSupplyError, setDateOfSupplyError,
	orderDate, onOrderDateChange, orderDateError, setOrderDateError,
	orderNumber, onOrderNumberChange, orderNumberError, setOrderNumberError,
	productDescription, onProductDescriptionChange, productDescriptionError, setProductDescriptionError,
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Create Invoice'
		buttonLabel='Create Invoice'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<div className='g_flex_h g_flex_top'>
			<div className='col'>
				<InputSelectSF type='text' name='s_customerId' maxLength={40}
					label='Customer'
					value={customerId} onChange={onCustomerIdChange} optionList={customerList}
					error={customerIdError} setError={setCustomerIdError}
				/>
				<InputTextSF type='text' name='s_InvoiceName' required={true} maxLength={40}
					label='Invoice name'
					value={invoiceName} onChange={onInvoiceNameChange}
					error={invoiceNameError} setError={setInvoiceNameError}
				/>
				{/* <InputDateUI type='text' name='s_DueDate' required={true}
                    label='Due Date' 
                    onChange={onDueDateChange} selectedDateISO={dueDate}
                    error={dueDateError} setError={setDueDateError}
                /> */}
				<InputTextSF type='text' name='s_customerNotes' maxLength={250}
					label='Notes'
					value={customerNotes} onChange={onCustomerNotesChange}
					error={customerNotesError} setError={setCustomerNotesError}
				/>
				<InputTextSF type='text' name='invoiceNumber' maxLength={40}
					label='Invoice number'
					value={invoiceNumber} onChange={onInvoiceNumberChange}
					error={invoiceNumberError} setError={setInvoiceNumberError}
				/>
			</div>
			<div className='g_m_left_100 col'>
				<InputTextSF type='text' name='eWayBill' maxLength={40}
					label='E-way bill'
					value={eWayBill} onChange={onEWayBillChange}
					error={eWayBillError} setError={setEWayBillError}
				/>
				<InputTextSF type='text' name='vehicleNumber' maxLength={250}
					label='Vehicle number'
					value={vehicleNumber} onChange={onVehicleNumberChange}
					error={vehicleNumberError} setError={setVehicleNumberError}
				/>
				<InputDateUI context={context} type='text' name='dateOfSupply' maxLength={40}
					label='Date of supply'
					selectedDateISO={dateOfSupply} onChange={onDateOfSupplyChange} optionList={customerList}
					error={dateOfSupplyError} setError={setDateOfSupplyError}
				/>
				<InputDateUI context={context} type='text' name='orderDate' maxLength={40}
					label='Order date'
					selectedDateISO={orderDate} onChange={onOrderDateChange}
					error={orderDateError} setError={setOrderDateError}
				/>
			</div>
			<div className='g_m_left_100 col'>
				<InputTextSF type='text' name='orderNumber' maxLength={250}
					label='Order number'
					value={orderNumber} onChange={onOrderNumberChange}
					error={orderNumberError} setError={setOrderNumberError}
				/>
				<InputTextSF type='text' name='productDescription' maxLength={40}
					label='Product description'
					value={productDescription} onChange={onProductDescriptionChange}
					error={productDescriptionError} setError={setProductDescriptionError}
				/>

			</div>
		</div>
	</ModalFormUI>

export default CustomerInvoicesCreateModalUI;
